import React, { useEffect, useState } from "react";
import { projectsData, projectsNav } from "./Data";
import WorkItems from "./WorkItems";
import FilterDropdown from "../ui/FilterDropdown";

// Helper hook for responsive window size
const useWindowWidth = () => {
    const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
    
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    return width;
};

const Works = () => {
    const [item, setItem] = useState({ name: 'all' });
    const [projects, setProjects] = useState([]);
    const [active, setActive] = useState(0);
    const width = useWindowWidth();

    useEffect(() => {
        if(item.name === "all") {
            const newProjects = projectsData
                .filter((project) => project.category !== "certificate")
                .slice().reverse();
            setProjects(newProjects);
        } else {
            const newProjects = projectsData
                .filter((project) => project.category === item.name)
                .slice().reverse();
            setProjects(newProjects);
        }
    }, [item]);

    const handleSelect = (name, index) => {
        setItem({ name });
        setActive(index);
    };

    // Calculate columns based on width
    let numCols = 3;
    if (width < 576) {
        numCols = 1;
    } else if (width < 992) {
        numCols = 2;
    }

    // Split projects into columns
    const columns = Array.from({ length: numCols }, () => []);
    projects.forEach((project, index) => {
        columns[index % numCols].push(project);
    });

    return (
        <div>
            {/* Desktop: standard tabs */}
            <div className="work-filters work-filters--desktop">
                {projectsNav.map((nav, index) => {
                    return (
                        <span 
                            onClick={() => {
                                handleSelect(nav.name, index);
                            }} 
                            className={`${active === index ? 'active-work' : ""} work-item`}
                            key={index}
                        >   
                            {nav.name}
                        </span>
                    );
                })}
            </div>

            {/* Mobile: dropdown selector */}
            <div className="work-filters--mobile">
                <FilterDropdown
                    value={item.name}
                    options={projectsNav}
                    onChange={(name) => {
                        const index = projectsNav.findIndex(n => n.name === name);
                        handleSelect(name, index);
                    }}
                />
            </div>

            <div className="work-container container">
                {columns.map((col, colIndex) => (
                    <div className="work-column" key={colIndex}>
                        {col.map((item) => (
                            <WorkItems item={item} key={item.id} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Works;